import { render, staticRenderFns } from "./searPage.vue?vue&type=template&id=f05a4d28&scoped=true"
import script from "./searPage.vue?vue&type=script&lang=js"
export * from "./searPage.vue?vue&type=script&lang=js"
import style0 from "./searPage.vue?vue&type=style&index=0&id=f05a4d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05a4d28",
  null
  
)

export default component.exports